window.concrete = window.concrete || {};

// perhaps turn into an assign in function?
concrete.strings = {
  soldOut: "Sold out",
  addToCart: "Add to bag",
  addedToCart: "Added!",
  unavailable: "Unavailable"
};

concrete.urlParams = {};

/*================ Concrete ================*/
// =require concrete/cache.js
/*
Task: Create a new url with a specified parameters value changed
Settings:
  url: Url that you wish to change
  paramName: Name of the parameter you want to change
  paramValue: the value you want to change it to
*/
concrete.replaceUrlParameter = function(url, paramName, paramValue){
    if (paramValue == null)
      paramValue = '';
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|$)')
    if (url.search(pattern)>=0){
      return url.replace(pattern,'$1' + paramValue + '$2');
    }
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue
}
/*
Task: Create a new url with a new url parameter and value, whilst maintaining the existing parameters and hash.
Settings:
  url: Url that you are wanting to change
  paramName: the parameter name you want to add
  paramValue: the value of the parameter you want to add
  replace: Default is true. When true if you try to add a parameter that already exists in the url it will be over written.
*/
concrete.addUrlParameter = function(url, paramName, paramValue, replace) {
  replace = replace || true;
  var locat = url.split('?')[1] || '';
  var exists = locat.indexOf(paramName+'=') > -1 ? true : false;
  var urlSplit = url.split('#');
  var hash = urlSplit[1] ? '#'+ urlSplit[1] : '';
  Object.keys(concrete.getUrlParameters(locat)).length ? urlSplit[0]+='&' : urlSplit[0]+='?';

  if (replace && exists) {
    return concrete.replaceUrlParameter(url, paramName, paramValue)+hash;
  } else {
    return urlSplit[0]+paramName+'='+paramValue+hash;
  }
};
/*
Task: Apply or replace a series of parameters
Settings:
  url: Url that you are wanting to change
  paramString: a string of url parameters eg. page=1&foo=bar
*/
concrete.addUrlParameters = function(url, paramString) {
  var params = paramString.split('&');
  var allParams = concrete.getUrlParameters(url);
  for (var i = 0; i < params.length; i++) {
    var param = params[i].split('=');

    if (allParams.hasOwnProperty(param[0])){
      url = concrete.replaceUrlParameter(url, param[0], param[1]);
    } else {
      url = concrete.addUrlParameter(url, param[0], param[1]);
    }
  }
  return url;
};
/*
Task: Return a url with a specified parameter and it's value removed
Settings:
  url: Url that you are wanting to change
  paramName: The name of the parameter you want to remove, it's value will also be removed
*/
concrete.removeUrlParameter = function(url, paramName) {
  // Use this function incase we are not removing the url of the current page
  var value = concrete.getUrlParameterByName(paramName, url);
  var newUrl = '';
  if (url.indexOf('?'+paramName+'='+value) > -1) {
    if (location.search.split('&').length > 1) {
      newUrl = url.replace(paramName+'=', '').replace(value+'&', '');
    } else {
      newUrl = url.replace('?'+paramName+'=', '').replace(value, '');
    }
  } else if (url.indexOf('&'+paramName+'='+value) > -1) {
    newUrl = url.replace('&'+paramName+'=', '').replace(value, '');
  }

  return newUrl;
};

concrete.getUrlParameters = function(locat){
  var search = locat || location.search;
  parameters = {};
  if (search.length) {
    for (var value, i = 0, pairs = search.substr(1).split('&'); i < pairs.length; i++) {
      value = pairs[i].split('=');
      if (value.length > 1) {
        parameters[decodeURIComponent(value[0])] = decodeURIComponent(value[1]);
      }
    }
  }
  return parameters;
};

concrete.pushNewUrl = function(url, method) {
  method = method || 'push';
  if (method == 'push') {
    window.history.pushState({path: url}, '', url);
  } else {
    window.history.replaceState({path: url}, '', url);
  }
};

// Collection template sorting
concrete.getUrlParameterByName = function(parameter) {
  var url = decodeURIComponent(window.location.search.substring(1)),
      urlVariables = url.split('&'),
      parameterName;

  for (i = 0; i < urlVariables.length; i++) {
    parameterName = urlVariables[i].split('=');
    if (parameterName[0] === parameter) {
      return parameterName[1] === undefined ? true : parameterName[1];
    }
  }
};

concrete.handlebarsHelpers = function() {
  Handlebars.registerHelper('compare', function (v1, operator, v2, options) {
    'use strict';
    var operators = {
      '==': v1 == v2 ? true : false,
      '===': v1 === v2 ? true : false,
      '!=': v1 != v2 ? true : false,
      '!==': v1 !== v2 ? true : false,
      '>': v1 > v2 ? true : false,
      '>=': v1 >= v2 ? true : false,
      '<': v1 < v2 ? true : false,
      '<=': v1 <= v2 ? true : false,
      '||': v1 || v2 ? true : false,
      '&&': v1 && v2 ? true : false
    }
    if (operators.hasOwnProperty(operator)) {
      if (operators[operator]) {
        return options.fn(this);
      }
      return options.inverse(this);
    }
    return console.error('Error: Expression "' + operator + '" not found');
  });

  Handlebars.registerHelper('position', function (index, position, options) {
    if (index == position) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  Handlebars.registerHelper('size', function (object, amount, options) {
    var size = 0;
    for (key in object) {
      if (object.hasOwnProperty(key)) size++;
    }
    if (size > amount) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('split', function(content, split, position, options) {
    var split = content.split(split);
    return split[position];
  });

  Handlebars.registerHelper('replace', function(content, find, replace, options) {
    return (content || '').replace(find, replace);
  });

  Handlebars.registerHelper('money', function (amount, format, options) {
    //format = '';
    format = TWP.moneyFormat;
    return new Handlebars.SafeString('<span class=\'money\'>' + Currency.formatMoney(amount, format) + '</span>');
  });

  Handlebars.registerHelper('math', function (value1, operator, value2, options) {
    'use strict';
    var v1 = Number(value1);
    var v2 = Number(value2);
    var operators = {
      '+': v1 + v2,
      '-': v1 - v2,
      '*': v1 * v2,
      '/': v1 / v2
    }
    if (operators.hasOwnProperty(operator)) {
      return new Handlebars.SafeString(operators[operator]);
    }
    return console.error('Error: Expression "' + operator + '" not found');
  });

  Handlebars.registerHelper('mathMoney', function (amount, operator, amount2, format, options) {
    'use strict';
    format = '';
    var operators = {
      '+': amount + amount2,
      '-': amount - amount2,
      '*': amount * amount2,
      '/': amount / amount2
    }
    if (operators.hasOwnProperty(operator)) {
      return new Handlebars.SafeString('<span class=\'money\'>' + operators[operator] + '</span>');
    }
    return console.error('Error: Expression "' + operator + '" not found');
  });

  Handlebars.registerHelper('cartMoneyShipping', function (amount, operator, amount2, format, options) {
    'use strict';
    format = '';
    var operators = {
      '+': amount + amount2,
      '-': amount - amount2,
      '*': amount * amount2,
      '/': amount / amount2
    }
    if (operators.hasOwnProperty(operator)) {
      format = TWP.moneyFormat;
      return new Handlebars.SafeString('<span class=\'money\'>' + Currency.formatMoney(operators[operator], format) + '</span>');
    }
    return console.error('Error: Expression "' + operator + '" not found');
  });

  Handlebars.registerHelper('handleize', function (string, options) {
    return concrete.handleize(string);
  });

  Handlebars.registerHelper("repeat", function (repetitions, index, min, max, opts) {
    min = min || -999999;
    max = max+1 || 999999;
    index = index || 0;
    var out = "";
    var start = Number(index);
    start = start >= min ? start : min;
    var end = start + repetitions;
    end = end < max ? end : max;
    if (end) {
      for(i = start; i < end; i++) {
        out += opts.fn(i);
      }
    } else {
      out = opts.inverse(this);
    }
    return out;
  });
}

concrete.urlParams = concrete.getUrlParameters();

// Javascript helpers for users with visual impairment

concrete.a11y = {

  // For use after scrolling using an anchor link, focus will change to the correct location so that hitting tab does not scroll the user back up.
  pageLinkFocus: function($element) {

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .data('a11y-focus')
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeData('a11y-focus')
        .removeAttr('tabindex');
    }
  },
  // Detect if the user has visited an anchored url if so update the focus to the correct location
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },
  // On click of an anchor link fire the page focus function
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },
  // Traps the focus within a specific container for example a popup that is open
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  // Stop trapping of focus
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }

}

concrete.Currency = (function() {

  var moneyFormat = '<span class="money">${{amount}}<span>';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '',
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;

    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
}

  return {formatMoney: formatMoney};

})();

/**
 *
 * From Shopifys "Slate" theme.
 * With a few modifications here and there.
 *
 */
concrete.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:section:reorder', this._onSectionReorder.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deslect', this._onBlockDeselect.bind(this));
};

concrete.Sections.prototype = _.assign({}, concrete.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof(constructor) === 'undefined') {
      return;
    }

    var instance = _.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-type]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter( function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);
      if (isEventInstance) {
        if (typeof(instance.onUnload) === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    var instance = this.instances.filter(function(instance) {
      return instance.id === evt.detail.sectionId;
    })[0];

    if (typeof(instance) !== 'undefined' && typeof(instance.onSelect) === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this.instances.filter(function(instance) {
      return instance.id === evt.detail.sectionId;
    })[0];

    if (typeof(instance) !== 'undefined' && typeof(instance.onDeselect) === 'function') {
      instance.onDeselect(evt);
    }
  },

_onSectionReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSectionReorder === 'function') {
      instance.onSectionReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this.instances.filter(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (typeof(instance) !== 'undefined' && typeof(instance.onBlockSelect) === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this.instances.filter(function(instance) {
      return instance.id === evt.detail.sectionId;
    })[0];

    if (typeof(instance) !== 'undefined' && typeof(instance.onBlockDeselect) === 'function') {
      instance.onBlockDeselect(evt);
    }
  },
  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(idx, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

// Javascript image helpers
concrete.Images = (function() {

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }
    for (var i = 0; i <= images.length-1; i++) {
      this.imageLoad(this.getImageUrl(images[i], size));
    }
  }

  function imageLoad(url) {
    var newImage = new Image().data.src = url;
    newImage.addClass("lazyload")
  }

  function getImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return concrete.Images.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|tiff|tif|bmp|bitmap)(\?v=\d+)$/i);

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return concrete.Images.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;

  }

  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  function switchImage(element, image, callback) {
    var oldSize = imageSize(element.src)
    var newSize = imageSize(image.src);
    var newImage = image.src;

    // If the iamge already has the size parameter remove it
    if (newSize !== null) {
      newImage = newImage.replace('_'+newSize, '')
    }

    var imageUrl = getImageUrl(newImage, oldSize);

    if (typeof callback === 'function') {
      callback(imageUrl, size, element);
    } else {
      element.src = imageUrl;
    }
  }

  function removeProtocol(url) {
    return url.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    getImageUrl: getImageUrl,
    imageSize: imageSize,
    imageLoad: imageLoad,
    switchImage: switchImage,
    removeProtocol: removeProtocol,
  };

})();

concrete.Collection = (function() {

  function Collection(container) {
    var $container = this.$container = $(container);
    this.selectors = {
      viewBy: '[data-view]',
      sortBy: '[data-sort]',
    }

    $container.on('change', this.selectors.sortBy, this._onSortByChange.bind(this));
    $container.on('click', this.selectors.viewBy, this._onViewByChange.bind(this));
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {

    _getSortBy: function() {
      return $(this.selectors.sortBy+' option:selected').val();
    },

    _onSortByChange: function() {
      var sortBy = this._getSortBy();
      this.$container.trigger({
        type: 'sortByChange',
        sortBy: sortBy,
      });
      concrete.urlParams.sort_by = this.currentSortBy = sortBy;
      // Push the sort method to the browser history and url
      concrete.pushNewUrl(concrete.replaceUrlParameter(window.location.href, 'sort_by', this.currentSortBy), 'replace');
    },

    _onViewByChange: function(evt) {
      evt.preventDefault();
      var viewBy = evt.target.getAttribute('data-view');

      this.$container.trigger({
        type: 'viewByChange',
        sortBy: viewBy,
      });

      concrete.urlParams.view = this.currentViewBy = viewBy;
      location.search = jQuery.param(concrete.urlParams);
    },

    onUnload: function() {
      this.$container.off();
    }

  });
  return Collection;
})();


// Tabs
concrete.Tabs = (function() {
  function Tabs() {
    $(document).on('click', '[data-trigger="tab"]', function(event) {
      if ( !($(this).parents('.theme-nav-toggled').length && $(this).hasClass('active')) ) {
        event.preventDefault();
        var target = $(this).data('target');

        if ( $(this).parents('.theme-nav-toggled').length ) {
          $('.theme-nav-toggled').find('[data-trigger="tab"]').removeClass('active');
          $('.theme-nav-toggled .visible').removeClass('visible').addClass('hidden');
        } else {
          $(this).siblings('[data-trigger="tab"]').removeClass('active');
          $(target).siblings('.visible').removeClass('visible').addClass('hidden').find('[data-slick].slick-initialized').slick('unslick');
        }

        $(this).addClass('active');
        $(target).removeClass('hidden').addClass('visible');

        if (typeof $(this).attr('data-trigger-slick') !== "undefined") {
          setTimeout(function() {
            $(target).find('[data-slick]:not(.slick-initialized)').slick();
            $(target).find('.hidden').find('[data-slick].slick-initialized').slick('unslick');
          }, 100);
        }
      }
    });
  }

  return Tabs();
})();

// Expands
concrete.Expands = (function() {
  function Expands() {
    $(document).on('click', '[data-trigger="expand"]', function(event) {
      event.preventDefault();
      var target = $(this).data('target'),
          preview = $(this).data('target-preview');

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(preview).slideDown(250).addClass('active');
        $(target).slideUp(250).removeClass('active');
      } else {
        $(this).addClass('active');
        $(target).slideDown(250).addClass('active');
        $(preview).slideUp(250).removeClass('active');
      }

    });
  }

  return Expands();
})();

// Accordions
concrete.Accordion = (function() {
  $(document).on('click', '[data-trigger="accordion"]', function(event) {
    event.preventDefault();
    var target = $(this).data('target');

    if ($(target).is(':visible')) {
      $(this).removeClass('active');
      $(target).slideUp(250).removeClass('visible');
    } else {
      $(this).closest('[data-collapse]').siblings('[data-collapse]').find('[data-trigger="accordion"]').removeClass('active').siblings('.visible').slideUp(250).removeClass('visible');
      $(this).addClass('active');
      $(target).slideDown(250).addClass('visible');
      setTimeout(function() {
        $(target).find('[data-auto-focus]').focus();
      }, 250);
      $(target).find('[data-auto-focus]').focus();

      if ($('.slick-initialized', target).length) {
        $('.slick-initialized', target).slick('resize');
      }
    }

    if (typeof(Sticky.elements['#CollectionSidebar']) != 'undefined') {
      setTimeout(function() {
        Sticky.elements['#CollectionSidebar'].scroll();
      }, 250);
    }
  });

  $(document).on('click', '[data-trigger="accordion"].active [data-accordion-no-trigger]', function(event) {
    event.stopPropagation();
    var target = $(this).closest('a[href]').attr('href');

    window.location.href = target;
  });
})();

$(document).on('click', '[data-account-redirect]', function(event) {
  event.preventDefault();

  var href = $(this).attr('href');
  Cookies.set('AccountRedirect', $(this).data('account-redirect'));
  window.location.href = href;
});

/*
 * if a search has been performed,
 * check if the search term matches one of the mobile nav tabs, eg. womens..., mens...
 * if so set that as the currently selected tab
 */
$(document).ready(function() {
  var getUrlParam = function(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    return results[1] || null;
  }
  var searchTerm = getUrlParam('q');
  if (searchTerm) {
    var $navItems = $('.main-menu [data-trigger="tab"]');
    $navItems.each(function() {
      if (searchTerm.toLowerCase().indexOf(this.title.toLowerCase()) !== -1) {
        var target = $(this).data('target');

        if ( $(this).parents('.theme-nav-toggled').length ) {
          $('.theme-nav-toggled').find('[data-trigger="tab"]').removeClass('active');
          $('.theme-nav-toggled .visible').removeClass('visible').addClass('hidden');
        } else {
          $(this).siblings('[data-trigger="tab"]').removeClass('active');
          $(target).siblings('.visible').removeClass('visible').addClass('hidden').find('[data-slick].slick-initialized').slick('unslick');
        }

        $(this).addClass('active');
        $(target).removeClass('hidden').addClass('visible');

        return false; // break out of jquery each loop
      }
    });
  }
});

concrete.Variants = (function() {

  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assign({}, Variants.prototype, {

    _getCurrentOptions: function() {
      var currentOptions = _.map(jQuery(this.singleOptionSelector, this.$container), function(el) {
        var $element = $(el);
        var type = $element.attr('type');
        var currentOption = {};
        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.attr('data-index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          return currentOption;
        }
      });

      currentOptions = _.compact(currentOptions);
      return currentOptions;
    },

    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = variants.filter(function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      return found[0];
    },

    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;
    },

    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      // console.log(currentVariantImage)

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      // Push the variant attribute to the browser history and url
      concrete.pushNewUrl(concrete.replaceUrlParameter(window.location.href, 'variant', variant.id), 'replace');
    },

    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;

})();

concrete.Validation = (function() {

  $(document).on('submit', 'form', function(event, success) {
    success = success || false;

    if (success) {
      return;
    }
    event.preventDefault();

    var errors = [];
    var $inputs = $(this).find('input');
    var $selects = $(this).find('select');

    $inputs.each(function() {
      $(this).removeClass('error');
      if ($(this).prop('required') && $(this).val() === "") {
        errors.push($(this).attr('id')+' is required.')
        $(this).addClass('error');
      }
    });
    $selects.each(function() {
      $(this).removeClass('error');
      if ($(this).prop('required') && $(this).val() === "") {
        errors.push($(this).attr('id')+' is required.')
        $(this).parent('.select-wrapper').addClass('error');
      }
    });

    if (errors.length !== 0) {
      return;
    }
    $(this).trigger('submit', [true]);
  });

})();

concrete.Product = (function() {

  function Product(container) {
    var $container = this.$container = $(container);
    //var sectionId = $container.attr('data-section-id');
    this.settings = {
      enableHistoryState: $container.data('enable-history-state') || false,
    };

    // Create our selectors
    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '#AddToCartText',
      comparePrice: '#ComparePrice',
      originalPrice: '.ProductPrice',
      offSale: '#ProductPrice',
      onSale: '#OnSale',
      inventory: '#ProductInventory',
      inventoryQuantity: '#ProductInventoryQuantity',
      inventoryThreshold: 'inventory-threshold',
      variantInventoryQuantity: 'variant-inventory',
      originalSelectorId: '#ProductSelect',
      singleOptionSelector: '.single-option-selector',
      variantId: '[name=id]',
      relatedProducts: '.related-products__row',
      stitchedProductsContainer: '.product__stitching',
      stitchedProductsCarousel: '.stitched-products',
      stitchedProductsNextArrow: '.nextArrow',
      stitchedProductsPrevArrow: '.prevArrow',
      upsellAddToCart: '[data-upsell-add-to-cart]',
    };
    // Find the product json
    if (!$('#ProductJson').html()) {
      return;
    }


    this.productSingleObject = JSON.parse(document.getElementById('ProductJson').innerHTML);
    this._stringOverrides();
    this._initVariants();
    this._initStitchedProducts();
    this._initUpsells();
  }


  Product.prototype = _.assignIn({}, Product.prototype, {

    _stringOverrides: function() {
      concrete.productStrings = concrete.productStrings || {};
      _.extend(concrete.strings, concrete.productStrings);
    },

    _initStitchedProducts: function() {
      const self = this;

      $(this.selectors.stitchedProductsCarousel).on('init', function() {
        $(self.selectors.stitchedProductsContainer).addClass('visible');
      });

      $(this.selectors.stitchedProductsCarousel).slick({
        infinite: false,
        dots: true,
        slidesToShow: 6,
        prevArrow: $(this.selectors.stitchedProductsPrevArrow),
        nextArrow: $(this.selectors.stitchedProductsNextArrow),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              swipeToSlide: true,
            }
          }
        ]
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        product: this.productSingleObject,
      };

      this.variants = new concrete.Variants(options);
      this.$container.on('variantChange', this._updateAddToCart.bind(this));
      this.$container.on('variantChange', this._updateVariantId.bind(this));
      this.$container.on('variantChange', this._updatePrices.bind(this));
      this.$container.on('variantChange', this._updateInventory.bind(this));
    },

    _initUpsells: function() {
      $(this.selectors.upsellAddToCart).on('click', function(e) {
        var target = e.target;
        var variantsSelector = $(target).prev().find('.upsells-item__variants');

        if (variantsSelector && variantsSelector.val()) {
          var variantID = variantsSelector.val();
          CartFox.addItem(variantID, 1);
        }
      })
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;
      $(this.selectors.productPrices).removeClass('hidden');

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(concrete.strings.addToCart);
        } else {
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(concrete.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(concrete.strings.unavailable);
        $(this.selectors.productPrices).addClass('hidden');
      }
    },

    _updatePrices: function(evt) {
      // console.log('updating variants')
      var variant = evt.variant;
      // console.log(variant)
      // console.log(variant.price)
      $(this.selectors.originalPrice).html(Currency.formatMoney(variant.price, TWP.moneyFormat));
      if (variant.price < variant.compare_at_price) {
        $(this.selectors.offSale).addClass('hidden');
        $(this.selectors.onSale).removeClass('hidden');
        $(this.selectors.comparePrice).html(Currency.formatMoney(variant.compare_at_price, TWP.moneyFormat))
      } else {
        $(this.selectors.onSale).addClass('hidden');
        $(this.selectors.offSale).removeClass('hidden');
      }
    },

    _updateInventory: function(evt) {
      var variant = evt.variant;
      var inventory = $(this.selectors.originalSelectorId).find('option[value="'  + variant.id + '"]').data(this.selectors.variantInventoryQuantity);
      var threshold = $(this.selectors.inventory).data(this.selectors.inventoryThreshold);

      $(this.selectors.inventoryQuantity).html(inventory);
      if ((inventory <= threshold) && (inventory > 0)) {
        $(this.selectors.inventory).removeClass('hidden');
      } else {
        $(this.selectors.inventory).addClass('hidden');
      }
    },

    _updateVariantId: function(evt) {
      var variant = evt.variant;
      if (variant)
        $(this.selectors.variantId).val(variant.id);
    },

    onUnload: function() {
      this.$container.off();
    }

  });

  return Product;
  // intialize self
})();

/**
 *  This is an example of a new sections javascript. When you call: sections.register('empty-section', EmptySection)
 * the function EmptySection() will fire with a container set to $('[data-section-type=empty-section]')
 * This is also fired when the shopify:section:onload event fires.
 * You can edit the individual events to modify what happens in the theme editor yourself; but be aware that EmptySection() is also fired on page load on the live site.
 * Any functions unique to your section should do inside the EmptySection.prototype object and the function name should be preceeded with an _.
 * Format: _myFunction: function(arguments) { //Function code }.
 * Settings can be passed to this.settings by adding data attributes to your sections parent div and selecting them inside this.settings.
 **/
concrete.EmptySection = (function() {
  function EmptySection(container) {
    var $container = $(container);
    var sectionId = $container.data('section-id');
    this.settings = {};
    this.selectors = {};
  }

  EmptySection.prototype = _.assignIn({}, EmptySection.prototype, {
    onSectionUnload: function(evt) { },
    onSectionSelect: function(evt) { },
    onSectionDeselect: function(evt) { },
    onBlockSelect: function(evt) { },
    onBlockDeselect: function(evt) { },
  });

  return EmptySection;
})();

var Q = function Q(configuration) {
  var defaultConfig = {
    success: null,
    error: null,
    method: 'GET',
    url: '',
    dataType: null,
    data: null,
  };
  this.config = Object.assign(defaultConfig, configuration);
  this.queue = [];
  this.processing = false;
  this.add = this.add.bind(this);
  this.process = this.process.bind(this);
}

Q.prototype.add = function addRequestToQueue(req) {
  var request = Object.assign({}, this.config, req);
  var defaultSuccess = this.config.success || function success(success) {
    jQuery(document).trigger('Q:requestCompleted', [success]);
  }
  var defaultError = this.config.error || function error(error) {
    jQuery(document).trigger('Q:requestFailed', [error]);
  }
  request.success = [request.success];
  this.queue.push(request);

  if (this.processing) {
    return true;
  }

  try {
    jQuery(document).trigger('Q:requestStarted');
  } catch (error) {
    console.error('Q:' + error);
  }

  this.processing = false;
  this.process();
  return this.processing;
}

Q.prototype.process = function processQueue(req) {

  if (!this.queue.length) {
    this.processing = false;
    jQuery(document).trigger('Q:requestsCompleted');
    return true;
  }
  this.processing = true;
  var request = this.queue.shift();
  request.success.push(this.process);
  try {
    jQuery.ajax(request);
  } catch (error) {
    console.error('Q:' + error);
  }

  return request;
}


concrete.ProductCard = (function() {
  function ProductCard(container) {
    this.container = container;

    const buttons = this.container.querySelectorAll(
      ".collection-product__variant"
    );
    buttons.forEach(el =>
      el.addEventListener("click", this.variantClickHandler.bind(this))
    );
  }

  ProductCard.prototype.variantClickHandler = function(e) {
    e.preventDefault();
    const target = e.target;

    CartFox.addItem(target.dataset.variantId, 1);
  };

  return ProductCard;
})();

concrete.ProductModal = (function() {
  function ProductModal() {
    this.container = document.getElementById('ProductPopup');

    if (!this.container) return;

    this.productPopup = new Focus('#ProductPopup');
  }


  ProductModal.prototype.open = function(handle, type) {
    const self = this;

    if (this.container.dataset.product === handle) {
      self.productPopup.show();
      self.initEventListeners();
      return;
    }

    const url = '/products/' + handle + '?view=modal';

    jQuery.ajax({url: url})
      .done(function(response){
        const parser = new DOMParser();
        const ajaxContainer = parser.parseFromString(response, "text/html");
        const ajaxPopup = ajaxContainer.querySelector('.product-popup');

        if (type === 'free-upsell') {
          const ajaxProductPrice = ajaxContainer.querySelector('.product__price');
          ajaxProductPrice.innerHTML = 'Free';
        }

        self.container.innerHTML = ajaxPopup.innerHTML;
        self.container.dataset.product = ajaxPopup.dataset.product;

        self.productPopup.show();
        self.initEventListeners();
      });
  };


  ProductModal.prototype.initEventListeners = function() {
    const self = this;

    const $container = $(this.container);
    const originalSelector = self.container.querySelector('[name=id]');
    const productObjectElem = this.container.querySelector('#PopupProductJson');
    const productObject = JSON.parse(productObjectElem.innerHTML);

    // Initialise variants
    const variants = new concrete.Variants({
      $container: $container,
      enableHistoryState: false,
      singleOptionSelector: '.single-option-selector',
      product: productObject,
    });

    // Radio options switching
    const options = self.container.querySelectorAll('[data-variant-option]');
    if (options.length > 0) {
      options.forEach(function(option) {
        option.addEventListener('click', function(){
          const optionNo = option.dataset.variantOption;
          const variant = option.dataset.variantValue;

          const singleOptionSelector = self.container.querySelector('#PopupSingleOptionSelector-' + optionNo);

          if (singleOptionSelector) {
            singleOptionSelector.value = variant;
            singleOptionSelector.dispatchEvent(new Event('change'));
          }
        })
      });
    }

    $container.on('variantChange', function(evt) {
      var variant = evt.variant;
      if (variant) {
        $('[name=id]', $container).val(variant.id);
      }
    });

    // Handle add to cart
    const addToCartBtn = this.container.querySelector('[data-product-modal-add-to-cart]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(e){
        e.preventDefault();

        if (originalSelector) {
          var variantID = originalSelector.value;

          CartFox.addItem(variantID, 1, {
            _freeUpsell: true
          });

          self.productPopup.hide();
        }
      })
    }
  };

  return ProductModal;
})();


// Initialize on document ready
$(document).ready(function() {
  // Register sections js
  var sections = new concrete.Sections();
  sections.register('product', concrete.Product);
  sections.register('collection', concrete.Collection);

  // Product Card
  document.querySelectorAll('.collection-product').forEach(el => new concrete.ProductCard(el));

  // Handlebars helpers
  concrete.handlebarsHelpers();

  // Init matchHeight plugin
  $('.matchHeight').matchHeight({
    byRow: true,
    property: 'height'
  });

  // Event tracking via dataLayer
  const pageURL = new URL(window.location.href);
  const featureTracking = pageURL.searchParams.get('via-feature');

  if (featureTracking) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'contentClick',
      contentType: featureTracking,
    })
  }

  // Initialise best sellers carousel on collection page
  if ($('.collection-carousel').length > 0) {
    $('.collection-carousel').slick({
      infinite: false,
      slidesToShow: 1.5,
      dots: false,
      arrows: false,
      prevArrow: '<button class="slick-prev"><svg width="8" height="13" xmlns="http://www.w3.org/2000/svg"><path d="M7 12.5l-6-6 6-6" stroke="#010101" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button class="slick-next"><svg width="8" height="13" xmlns="http://www.w3.org/2000/svg"><path d="M1 .5l6 6-6 6" stroke="#010101" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 1180,
          settings: {
            arrows: true,
            slidesToShow: 5,
            slidesToScroll: 5,
          }
        },
      ]
    });
  }
})
